module.exports = __webpack_public_path__ + "static/media/ic_business_trip_apply.b9ec9355.png";